import React from 'react';
import { useTranslation } from 'react-i18next';
import { cssTransition, ToastContainer } from 'react-toastify';
import RevButton from './RevButton';

const transition = cssTransition({
    enter: 'rev-toast--enter',
    exit: 'rev-toast--exit',
    collapse: false,
});

/** Contenedor global: conserva la API y los tiempos de cada llamada a toast(). */
const RevToastContainer = () => {
    const { t } = useTranslation();
    return (
        <ToastContainer
            className="rev-toasts"
            toastClassName="rev-toast"
            bodyClassName="rev-toast__body"
            progressClassName="rev-toast__progress"
            transition={transition}
            closeButton={({ closeToast }) => (
                <RevButton
                    variant="subtle" size="sm" icon className="rev-toast__close"
                    aria-label={t('generic.alertButton.close')}
                    onClick={(event) => {
                        event.stopPropagation();
                        closeToast(event);
                    }}>
                    <span className="material-icons rev-icon-sm" aria-hidden="true">close</span>
                </RevButton>
            )}
        />
    );
};

export default RevToastContainer;
